import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import React, { useEffect } from "react";
import { DialogContentStyled, DialogContentTextStyled, StyledBox, StyledDialogTitle, StyledTypographyTitle, TextConfirmButtonStyled } from "./BasketListDialog.style";
import { AppIconsCart } from "../../../AppIcons";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { StyledDialogActions } from "./AddBasketButton.style";

export const DeleteBasketDialog: React.FC<{
    defaultOpen: boolean;
    onClose: any;
    onDelete: any;
    basketId: number;
}> = ({ onClose, onDelete, defaultOpen, basketId }) => {
    const [open, setOpen] = React.useState(defaultOpen);
    const { t } = useTranslation();
    useEffect(() => {
        setOpen(defaultOpen);
    }, [defaultOpen]);

    const handleClose = () => {
        setOpen(false);
        onClose(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-dialog-title"
            style={{ zIndex: 112000 }}
        >
            
          <StyledDialogTitle>
              <StyledBox style={{}}>
                 {/* <AppIconsCart />*/}
                  <StyledTypographyTitle variant="subtitle1">
                      {t("common.spareparts.basket.delete_title")}
                  </StyledTypographyTitle>
              </StyledBox>
          </StyledDialogTitle>
        
            <DialogContentStyled>
                <DialogContentTextStyled>
                    {t("common.spareparts.basket.delete_basket")}
                </DialogContentTextStyled>
            </DialogContentStyled>
            <StyledDialogActions>
                <TextConfirmButtonStyled
                    color="secondary"
                    onClick={handleClose}
                >
                    {t("common.spareparts.no")}
                </TextConfirmButtonStyled>
                <TextConfirmButtonStyled
                    variant="contained"
                    onClick={() => {
                        onDelete(basketId);
                    }}
                    color="primary"
                >
                    {t("common.spareparts.yes")}
                </TextConfirmButtonStyled>
            </StyledDialogActions>
        </Dialog>
    );
};
